export default "__VITE_ASSET__ea43f309__"